import { routePaths } from '../../routePaths';
import { NewTablesIcon } from '../../ui-kit';
import { translate } from '../../utils';
import { RouteType } from '../../types';
import { BackofficePermission, VenueType } from '../../generated/graphql';
import { Tables } from '../../modules';

const TablesRoute: RouteType = {
    exact: true,
    path: routePaths.tableMap,
    icon: NewTablesIcon,
    title: translate('Table Map'),
    component: Tables,
    allowedVenueTypes: [VenueType.Restaurant],
    permissions: {
        backoffice: [BackofficePermission.HasAccess]
    }
};

export default TablesRoute;
